import React from 'react'
import styled from '@emotion/styled'

const Container = styled.div`
  position: fixed;
  top: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const SnackbarWrapper = styled.div`
  width: 350px;
  height: 55px;
  background-color: #3e3f42;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Text = styled.p`
  color: white;
  font-size: 14px;
`

type Props = {
  text: Required<string>
}

const Snackbar = ({ text }: Props) => (
  <Container>
    <SnackbarWrapper>
      <Text>{text}</Text>
    </SnackbarWrapper>
  </Container>
)

export default Snackbar
